import { useCallback, useEffect, useState } from "react";
import { getMessageLogsByOrganizationAsync } from "../api/MessageApi";
import { MessageLog } from "../models/MessageModels";
import { Constants } from "../constants/constants";

interface UseMessageLogsReturn {
  logs: MessageLog[];
  loading: boolean;
  error: string | null;
  reload: () => Promise<void>;
}

export const useMessageLogs = (
  organizationId: string | undefined,
): UseMessageLogsReturn => {
  const [logs, setLogs] = useState<MessageLog[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async () => {
    if (!organizationId) {
      setLogs([]);
      setLoading(false);
      return;
    }

    setLoading(true);
    try {
      const token = localStorage.getItem(Constants.ACCESS_TOKEN) || "";
      const res = await getMessageLogsByOrganizationAsync(token, organizationId);
      if (res.success) {
        setLogs(res.result ?? []);
        setError(null);
      } else {
        setError(res.message || "Failed to load message logs");
      }
    } catch (err) {
      console.error(err);
      setError("Failed to load message logs");
    } finally {
      setLoading(false);
    }
  }, [organizationId]);

  useEffect(() => {
    load();
  }, [load]);

  const reload = useCallback(async () => {
    await load();
  }, [load]);

  return { logs, loading, error, reload };
};